var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.516,
    height: 15,
    viewBox: "0 0 13.516 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play-button-arrowhead",
    transform: "translate(-8.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67646",
    "data-name": "Path 67646",
    d: "M10.556.331C9.2-.445,8.107.19,8.107,1.749v11.5c0,1.56,1.1,2.195,2.449,1.42L20.608,8.9c1.353-.776,1.353-2.033,0-2.809Z",
    transform: "translate(0 0)",
    fill: "#e23744"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/playIcon.98683a9dc90e3cfacfdf76c1bb6ac802.svg";
export { ForwardRef as ReactComponent };